import { Skeleton } from 'antd';
import { Column, Icon, Row, Space, Text } from 'farmhub-ui-core';

import { theme } from 'styled';
import { ICONS } from 'utils/constants';

import {
  ImageMobile,
  ImageMobileWrapper,
  MobileWrapper,
  IconStyles,
  ImageWrapper,
  Wrapper,
} from './styles';

const CheckFilterItemMobile = ({
  selected = false,
  image,
  tooltip,
  width,
  height,
  typeSelectCreate = false,
  handleClick,
}: CheckFilterItemProps): JSX.Element => (
  <MobileWrapper
    height={height}
    selected={selected}
    typeSelectCreate={typeSelectCreate}
    width={width}
    onClick={handleClick}
  >
    <Column alignItems="center">
      <ImageMobileWrapper>
        {image ? (
          <ImageMobile src={image} />
        ) : (
          <Skeleton.Image style={{ width: '100%', height: '48px' }} />
        )}
      </ImageMobileWrapper>
      <Space height={6} />
      <Row
        justifyContent="center"
        styles={{ padding: `0px ${theme.app.padding.vertical}` }}
      >
        <Text
          lineNumber={2}
          size="xxs"
          styles={{
            'text-align': 'center',
            color:
              selected && typeSelectCreate
                ? theme.colors.primary.main
                : theme.colors.text.primary,
          }}
          weight="medium"
        >
          {tooltip}
        </Text>
      </Row>
    </Column>
    {selected && !typeSelectCreate && (
      <Icon
        styles={IconStyles}
        svgProps={{
          icon: ICONS.TICK,
          color: theme.colors.primary.main,
          width: '18px',
          height: '18px',
        }}
      />
    )}
  </MobileWrapper>
);

export default CheckFilterItemMobile;

export interface CheckFilterItemProps {
  image: string;
  tooltip: string;
  selected?: boolean;
  width?: string;
  height?: string;
  typeSelectCreate?: boolean;
  handleClick?: () => void;
}

export const CheckFilterItemSkeleton = ({
  width,
  height,
}: CheckFilterItemSkeletonProps): JSX.Element => (
  <Wrapper height={height} selected={false} width={width}>
    <Column alignItems="center">
      <ImageWrapper>
        <Skeleton.Avatar shape="square" size={48} />
      </ImageWrapper>
      <Space height={12} />
      <Skeleton.Input size="small" style={{ width: '100%' }} />
    </Column>
  </Wrapper>
);

export interface CheckFilterItemSkeletonProps {
  width?: string;
  height?: string;
}
